"use strict";
/** @format */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomain = void 0;
function getDomain(url) {
    return url
        .split('://')[1]
        .split('?')[0]
        .split('/')[0]
        .split('@')
        .slice(-1)[0]
        .split(':')[0];
}
exports.getDomain = getDomain;
